export default "__VITE_ASSET__CeKxPnGH__"